<template>
  <div class="user-search">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>検索</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="会社名:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.company" placeholder="会社名" />
          </b-form-group>
          <b-form-group label="名前:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.name" placeholder="名前" />
          </b-form-group>
          <b-form-group label="メールアドレス:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.email" placeholder="メールアドレス" />
          </b-form-group>
          <b-form-group label="備考:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.comment" placeholder="備考" />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">検索</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
let defaultConditions = {
  name: '',
  email: '',
};

export default {
  name: 'UserSearch',

  data() {
    return {
      conditions: Object.assign({}, defaultConditions),
    };
  },

  methods: {
    onSubmit(evt) {
      let options = {
        limit: this.$store.state.users.limit,
        page: 1,
        sortBy: this.$store.state.users.sortBy,
        sortDesc: this.$store.state.users.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('users/searchList', options);
    },

    onReset(evt) {
      this.conditions = Object.assign({}, defaultConditions);
      let options = {
        limit: this.$store.state.users.limit,
        page: 1,
        sortBy: this.$store.state.users.sortBy,
        sortDesc: this.$store.state.users.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('users/searchList', options);
    },
  },
};
</script>

<style scoped>
</style>
